import { EErrorMessages } from 'app/types/errorMessages';
import * as Sentry from '@sentry/react';
import toast from 'react-hot-toast';

export const getASDProtocolLink = (jobId: string, versionId?: string): string => {
  const location = window.location.hostname;

  let url = jobId;
  if (versionId) {
    url += `?version=${versionId}`;
  }

  console.log(`ASD version string: ${url}`);

  if (location === 'www.autoscript.ai') {
    return `autoscript://${url}`;
  }
  if (location === 'staging.autoscript.ai') {
    return `as://${url}`;
  }
  if (location === 'demo.autoscript.ai') {
    return `asd://${url}`;
  }
  // using staging for local development
  return `as://${url}`;
};

export const getLinkPrefix = (): string => {
  return `${window.location.origin}/share/job/`;
};

export const handleOpenDesktop = async (jobId: string, versionId?: string | null) => {
  let url = `${getLinkPrefix()}${jobId}`;
  if (versionId) {
    url += `?version=${versionId}`;
  }
  document.location = url;
  return;
};

export const triggerBrowserDownload = (url: string, fileName: string) => {
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const handleDownloadError = (error: unknown) => {
  toast.error(EErrorMessages.UNABLE_TO_DOWNLOAD);
  Sentry.captureException(new Error('Failed to download the file'), {
    extra: { error },
  });
  console.error('Failed to download the file', error);
};
